import { apiSlice } from "../../app/api/apiSlice";

/**
 * /audit            → all actions   (optionally ?limit & skip)
 * /audit/:username  → actions for one user
 */
export const actionLogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getActions: builder.query({
      query: ({ limit = 100, skip = 0 } = {}) => ({
        url: "/audit",
        params: { limit, skip },
      }),
    }),
    getActionsByUser: builder.query({
      query: ({ username, limit = 100, skip = 0 }) => ({
        url: `/audit/${username}`,
        params: { limit, skip },
      }),
    }),
    /* 🔸 page-view or any ad-hoc event */
    logAction: builder.mutation({
      query: (payload) => ({
        url: "/audit",
        method: "POST",
        body: payload,          // { action , details }
      }),
    }),
  }),
});

export const {
  useGetActionsQuery,
  useGetActionsByUserQuery,
  useLogActionMutation
} = actionLogApiSlice;
